import type { KeyboardEvent } from 'react';
import { findNextTabbable, getTabbableElements } from './tabbableHelper';

export const tabOnFromUntabbable = (event: KeyboardEvent<HTMLElement>) => {
  if (event.key !== 'Tab' || event.defaultPrevented) return;
  if (event.ctrlKey || event.metaKey || event.altKey) return;
  const from = event.target;
  if (!(from instanceof HTMLElement) || from.tabIndex >= 0) return;
  // A dialog's keys bubble up through React from its portal; the dialog keeps Tab inside itself.
  if (!event.currentTarget.contains(from)) return;
  const next = findNextTabbable(getTabbableElements(event.currentTarget), from, event.shiftKey);
  if (!next) return;
  event.preventDefault();
  event.stopPropagation();
  next.focus();
};
